import { Box, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import { catalogs } from '../../../../../../utils/catalogs';
import { CONFIG_SETTINGS } from '../../../../../../config';
import { CustomSmallSelect } from '../../../../../../components/custom-input';
import useDoctor from '../../../../../../hooks/api/useDoctor';
import { useParams } from 'react-router';
import Validator from 'validator'
import Iconify from '../../../../../../components/iconify';

const DoctorChatPrices = () => {

    const {iduser} = useParams()
    const doctorManager = useDoctor()
    const [busy, setBusy] = useState(false)
    const [currency_type, setCurrencyType] = useState(CONFIG_SETTINGS.CURRENCY_ID)
    const [prices, setPrices] = useState([])
    const [price, setPrice] = useState(0)
    const [error, setError] = useState(false)
    const [helperText, setHelperText] = useState("")

    const onUpdateCurrencyType = (e) => {
        setCurrencyType(e.target.value)
    }

    const onChange = (e) => {
        setPrice(e.target.value)
        setError(false)
        setHelperText("")
    }

    const onGetPrices = useCallback(async() => {
        try {
            const _prices = await doctorManager.actions.onGetChatPrices(iduser)
            setPrices(_prices)
            console.log(_prices, currency_type)
            const findPrice = _prices.find(el => el.currency_id == currency_type)
            console.log(findPrice)
            
            if(findPrice){
                console.log(findPrice.price)
                setPrice(findPrice.price)
            }
            
        } catch (error) {
            
        }
        
    }, [currency_type, iduser, currency_type])

    const onSubmit = useCallback(async(e) => {
        const _pricevalue = e.target.value

        if(!Validator.isCurrency(_pricevalue)){
            console.log("No es validao")
            setError(true)
            setHelperText("Debe ser un valor monetario válido")
        }else{
            setError(false)
            setHelperText("")
        }


        let data2send = {
            price:_pricevalue
        }

        setBusy(true)
        try {
            const findPrice = prices.find(el => el.currency_id == currency_type)
            if(!findPrice){
                // must create a doctor chat price
                data2send.currency_id = currency_type
                console.log("Crear", data2send)
                //await doctorManager.actions.onAddChatPrice(iduser, data2send)
                await onGetPrices()
            }else{
                // must patch an existing value
                console.log("Actualizar")
                await doctorManager.actions.onUpdateChatPrice(iduser, findPrice?.id_doctor_chat_price, data2send)
                await onGetPrices()
            }
        } catch (error) {
            
        }
        setBusy(false)
    }, [prices,currency_type])

    useEffect(() => {
        onGetPrices()
    }, [iduser, currency_type])

    return ( 
        <Box sx={{
            py:1
        }}>
            <Grid container alignItems='center' spacing={1}>
                <Grid item>
                    <Typography variant='subtitle2'>Precios de chat</Typography>
                </Grid>
                <Grid item>
                <CustomSmallSelect value={currency_type} onChange={onUpdateCurrencyType}>
                    {catalogs.currencies.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </CustomSmallSelect>
                </Grid>
            </Grid>
            <Box sx={{mt:1}}>
                <TextField
                    disabled={busy}
                    value={price}
                    type='number'
                    onBlur={onSubmit}
                    onChange={onChange}
                    fullWidth
                    InputProps={{
                        startAdornment:<Iconify icon="flowbite:dollar-solid"  />,
                        endAdornment: busy && <CircularProgress size={18} />
                    }}
                    error={error}
                    helperText={helperText}
                />
            </Box>
        </Box>
    );
}
 
export default DoctorChatPrices;